import React, { useState, useEffect } from 'react';
import { useMessagesStore } from '../../../zustand/store';
import styles from '../../../style/styles/PreQuestion.module.css';

export const MultiSelectInput = ({
  order,
  question,
  fields,
  onAnswer,
  onNext,
}) => {
  const { setMessages } = useMessagesStore();
  const [checked, setChecked] = useState(Array(fields[0].options.length).fill(false));
  const [selected, setSelected] = useState([]);
  const [inputValid, setInputValid] = useState(false);

  const handleChange = (e) => {
    const index = e.target.dataset.index;
    const newChecked = [...checked];
    newChecked[index] = e.target.checked;
    setChecked(newChecked);
  };

  useEffect(() => {
    let newSelected = [];
    fields[0].options.forEach((option, index) => {
      if (checked[index]) {
        newSelected.push(option);
      }
    });
    setSelected(newSelected);
    setInputValid(newSelected.length > 0);
  }, [checked, fields[0].options]);

  const handleButtonClick = () => {
    if (!inputValid) return;
    
    const selectedText = selected.join(', ');
    
    // 메시지에 추가
    setMessages([{ message: question, isChatbot: true }]);
    setMessages([{ message: selectedText, isChatbot: false }]);
    
    // 답변 전달
    onAnswer({ key: fields[0].key, answer: selectedText }, order);
    
    // 다음 단계로
    onNext();
  };

  const handleKeyPress = (e) => {
    e.stopPropagation();
    if (!inputValid) return;
    if (e.key === 'Enter') {
      e.preventDefault();
      handleButtonClick();
    }
  };

  return (
    <div 
      style={{
        width: '100%', 
        display: 'flex', 
        flexDirection: 'row', 
        alignItems: 'center', 
        justifyContent: 'flex-end', 
        padding: '0 16px'
      }} 
      onKeyDown={handleKeyPress}
      tabIndex={0}
    >
      <div style={{
        width: '100%', 
        display: 'flex', 
        flexDirection: 'row', 
        alignItems: 'center', 
        justifyContent: 'flex-end', 
        flexWrap: 'wrap', 
        gap: '8px'
      }}>
        {fields[0].options.map((option, index) => (
          <React.Fragment key={option}>
            <label 
              htmlFor={`${order}-${option}`}
              className={checked[index] ? styles.MultiSelect__option__checked : styles.MultiSelect__option}
            >
              <p className="h6 fc-gray-800">{option}</p>
            </label>
            <input 
              name={option} 
              type="checkbox" 
              id={`${order}-${option}`} 
              hidden 
              data-index={index}
              onChange={handleChange}
            />
          </React.Fragment>
        ))}
      </div>
      <button 
        onClick={handleButtonClick}
        className={inputValid ? styles.PreQuestion__submitButton : styles.PreQuestion__submitButton__disabled}
      >
        <p className="h1 fc-white">선택 완료</p>
      </button>
    </div>
  );
};
